/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Project_Import_TitleInputs */

const en_team_project_import_title = /** @type {(inputs: Team_Project_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import Team Project`)
};

const fr_team_project_import_title = /** @type {(inputs: Team_Project_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importer un projet d’équipe`)
};

const de_team_project_import_title = /** @type {(inputs: Team_Project_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importteam-Projekt`)
};

const it_team_project_import_title = /** @type {(inputs: Team_Project_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importa progetto di squadra`)
};

const ru_team_project_import_title = /** @type {(inputs: Team_Project_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проект импортной команды`)
};

const es_team_project_import_title = /** @type {(inputs: Team_Project_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proyecto de equipo de importación`)
};

const zh_cn2_team_project_import_title = /** @type {(inputs: Team_Project_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导入团队项目`)
};

const ja_team_project_import_title = /** @type {(inputs: Team_Project_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チームプロジェクトのインポート`)
};

const hi_team_project_import_title = /** @type {(inputs: Team_Project_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आयात टीम परियोजना`)
};

const pt_pt2_team_project_import_title = /** @type {(inputs: Team_Project_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projeto da Equipe de Importação`)
};

/**
* | output |
* | --- |
* | "Import Team Project" |
*
* @param {Team_Project_Import_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_project_import_title = /** @type {((inputs?: Team_Project_Import_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Project_Import_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_project_import_title(inputs)
	if (locale === "de") return de_team_project_import_title(inputs)
	if (locale === "it") return it_team_project_import_title(inputs)
	if (locale === "ru") return ru_team_project_import_title(inputs)
	if (locale === "es") return es_team_project_import_title(inputs)
	if (locale === "zh-CN") return zh_cn2_team_project_import_title(inputs)
	if (locale === "ja") return ja_team_project_import_title(inputs)
	if (locale === "hi") return hi_team_project_import_title(inputs)
	if (locale === "pt-PT") return pt_pt2_team_project_import_title(inputs)
	return en_team_project_import_title(inputs)
});